// Utility functions for event details extraction and formatting

// Convert ISO string to 'HH:mm:ss-05' (EST)
export function toPgTimeWithEST(isoString) {
    if (!isoString) return '';
    const dateObj = new Date(isoString);
    // Convert to EST (UTC-5)
    const utc = dateObj.getTime() + (dateObj.getTimezoneOffset() * 60000);
    const estOffset = -5; // EST is UTC-5
    const estDate = new Date(utc + (3600000 * estOffset));
    const hh = String(estDate.getHours()).padStart(2, '0');
    const mm = String(estDate.getMinutes()).padStart(2, '0');
    const ss = String(estDate.getSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss}-05`;
}

// Prepare agenda item payload for backend
export function buildAgendaItemPayload({ eventId, spaceId, item, userId }) {
    // Parse date from startTime (ISO format: 'YYYY-MM-DDTHH:mm:ss')
    let date = null;
    let startTime = item.startTime;
    let endTime = item.endTime;
    if (startTime && startTime.includes('T')) {
        date = startTime.split('T')[0];
    }

    // If endTime is missing or not a string, add 30 minutes to startTime
    if (!endTime || typeof endTime !== 'string' || endTime === '{}' || (typeof endTime === 'object' && Object.keys(endTime).length === 0)) {
        if (startTime) {
            const startDateObj = new Date(startTime);
            const endDateObj = new Date(startDateObj.getTime() + 30 * 60000); // add 30 minutes
            endTime = endDateObj.toISOString();
        } else {
            endTime = '';
        }
    }

    // Ensure description is a string
    let description = typeof item.description === 'string' ? item.description : '';

    // Prepare payload
    return {
        event_id: String(eventId),
        space_id: String(spaceId),
        name: String(item.title || ''),
        description,
        start_time: toPgTimeWithEST(startTime),
        end_time: toPgTimeWithEST(endTime),
        created_by: String(userId || ''),
        date: String(date || ''),
    };
} 